import { css } from '@emotion/css';

export const smallIconStyles = css`
  width: 1.8rem;
  height: 1.8rem;
  flex-shrink: 0;
`;

export const smallIconBorderRadius = css`
  border-radius: 0.4rem;
`;

export const mediumIconStyles = css`
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
`;

export const mediumIconBorderRadius = css`
  border-radius: 0.5rem;
`;

export const largeIconStyles = css`
  width: 2.4rem;
  height: 2.4rem;
  flex-shrink: 0;
`;

export const largeIconBorderRadius = css`
  border-radius: 0.6rem;
`;

export const mediumIndeterminateStyles = css`
  width: 0.7rem;
`;

export const circularCheckBoxFocusStyles = css`
  &.Mui-focusVisible {
    outline: 0.16rem solid transparent;
    box-shadow: 0 0 0 0.16rem var(--interactive-white), 0 0 0 0.32rem var(--focus-secondary);
  }
`;

export const checkBoxFocusStyles = css`
  &.Mui-focusVisible > div {
    outline: 0.16rem solid transparent;
    box-shadow: 0 0 0 0.16rem var(--interactive-white), 0 0 0 0.32rem var(--focus-secondary);
  }
`;

export const checkBoxStyles = css`
  color: var(--border);

  &:hover {
    color: var(--border-dark);
  }

  &.MuiIconButton-colorSecondary:hover,
  &.MuiCheckbox-colorSecondary.Mui-checked:hover {
    background: var(--bg-primary);
  }

  &:active {
    color: var(--focus-primary);
  }

  :focus {
    .ly-checkbox {
      border-color: var(--interactive-primary);
    }
  }

  &.Mui-checked {
    color: var(--interactive-primary);

    &:hover {
      color: var(--interactive-primary-hover);
    }

    &:active {
      color: var(--interactive-primary-active);
    }
  }

  &.Mui-disabled {
    opacity: 50%;
  }
`;
